// Adresse → Seite. Die App startet im Spielen-Modus, wenn keine (oder eine unbekannte) Unterseite
// in der Adresse steht; direkte Links auf Partien, Analyse, Taktik usw. bleiben, wo sie hinzeigen.
export type Route =
  | { name: 'library' }
  | { name: 'game'; id: number }
  | { name: 'analyse'; fen: string; flipped: boolean }
  | { name: 'editor'; fen: string | null; unsure: string[]; flipped: boolean }
  | { name: 'photo' }
  | { name: 'play'; query: string }
  | { name: 'puzzle' }
  | { name: 'setup' }
  | { name: 'wallpaper' };

export const START_FEN = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';

/** `hash` wie location.hash; ohne oder mit unbekannter Unterseite: Spielen */
export function parseRoute(hash: string, isPublic: boolean): Route {
  const game = /^#\/partie\/(\d+)/.exec(hash);
  if (game) return { name: 'game', id: +game[1] };
  const ana = /^#\/analyse(?:\/([^?]+))?(?:\?(.*))?$/.exec(hash);
  if (ana) {
    const q = new URLSearchParams(ana[2] ?? '');
    return { name: 'analyse', fen: ana[1] ? decodeURIComponent(ana[1]) : START_FEN, flipped: q.get('f') === '1' };
  }
  const ed = /^#\/editor(?:\/([^?]+))?(?:\?(.*))?$/.exec(hash);
  if (ed) {
    const q = new URLSearchParams(ed[2] ?? '');
    return {
      name: 'editor',
      fen: ed[1] ? decodeURIComponent(ed[1]) : null,
      unsure: (q.get('u') ?? '').split(',').filter(Boolean),
      flipped: q.get('f') === '1',
    };
  }
  if (hash.startsWith('#/foto')) return { name: 'photo' };
  if (hash.startsWith('#/taktik')) return { name: 'puzzle' };
  if (hash.startsWith('#/spielen')) return { name: 'play', query: hash.split('?')[1] ?? '' };
  if (hash.startsWith('#/setup')) return { name: 'setup' };
  if (hash.startsWith('#/wallpaper') && !isPublic) return { name: 'wallpaper' };
  if (hash.startsWith('#/bibliothek')) return { name: 'library' };
  return { name: 'play', query: '' };
}
